var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-aside',{attrs:{"width":"auto"}},[_c('industry-aside')],1),_c('el-container',[_c('el-header',[_c('industry-head')],1),_c('el-main',[_c('industry-main')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }